export const middlewareWrapper = func => store => next => action => {func(store, next, action)}


// WEBPACK FOOTER //
// ./utils/middlewareUtils.js